import { useTranslation } from 'react-i18next'

import { Button, Icon, Link, Modal, Text } from '@lounge-fe/ui-kit'

import { SizeGuideModalProps } from './types'
import { useSizeGuidesQuery } from '../hooks'
import classNames from 'classnames'

export const SizeGuideModal = ({
  sizeGuides,
  primaryAction,
  secondaryAction,
  buttonClassName,
}: SizeGuideModalProps) => {
  const hasSideGuides = !!sizeGuides?.length

  const { t } = useTranslation()

  if (!hasSideGuides) {
    return null
  }

  return (
    <Modal>
      <Modal.Trigger>
        <Link
          as="button"
          variant="body-sm"
          className={classNames('underline', buttonClassName)}
          type="button"
        >
          {t('product.size_guide')}
        </Link>
      </Modal.Trigger>
      <Modal.Content size="xl" isMobileFullscreen>
        <Modal.Header>
          <Text variant="title-four">{t('product.size_guide')}</Text>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body className="overflow-x-auto">
          {sizeGuides && sizeGuides.length ? (
            <div className="flex flex-col gap-8 my-4">
              {Object.values(sizeGuides).map((sizeGuide, index) => (
                <div
                  key={index}
                  dangerouslySetInnerHTML={{ __html: sizeGuide }}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col gap-8 my-4">
              <Text variant="body-sm">No size guides found</Text>
            </div>
          )}
          {(primaryAction || secondaryAction) && (
            <div className="grid sm:grid-flow-col auto-cols-fr justify-center gap-4 mb-6 max-w-[500px] mx-auto">
              {primaryAction && (
                <Button as="a" href={primaryAction.url} variant="solid">
                  {primaryAction.text}
                </Button>
              )}
              {secondaryAction && (
                <Button as="a" href={secondaryAction.url} variant="outline">
                  {secondaryAction.text}
                </Button>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  )
}
